import { combineReducers, configureStore } from '@reduxjs/toolkit';
import categoriesReducer from './reducers/CategoriesSlice';
import currenciesSlice from './reducers/CurrenciesSlice';
import merchantReducer from './reducers/MerchantsSlice';
import languageSlice from './reducers/LanguageSlice';

const rootReducer = combineReducers({
	categoriesReducer,
	currenciesSlice,
	merchantReducer,
	languageSlice
});

export const setupStore = () => {
	return configureStore({
		reducer: rootReducer,
	});
};

export type TRootState = ReturnType<typeof rootReducer>
export type TAppStore = ReturnType<typeof setupStore>
export type TAppDispatch = TAppStore['dispatch']
